export default __webpack_public_path__ + "static/media/about.47c39264.jpg";